import {
  FetchAudiosResponse,
  CreateAudioResponse,
  UpdateAudioResponse,
  DeleteAudioResponse,
} from '../types/audioTypes'
import { getAdminToken } from './admin'

const API_URL = process.env.REACT_APP_API_URL

// Helper to create auth headers for FormData requests (no Content-Type)
const createFormDataAuthHeaders = (): HeadersInit => {
  const token = getAdminToken()
  const headers: HeadersInit = {}
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  return headers
}

export const fetchAudios = async (): Promise<FetchAudiosResponse> => {
  try {
    const token = getAdminToken()
    const headers: HeadersInit = {}
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
    
    const response = await fetch(`${API_URL}/audio-podcasts`, { headers })
    const data = await response.json()
    if (response.ok) {
      return { success: true, audioPodcasts: data.audioPodcasts }
    } else {
      return {
        success: false,
        message: data.message || 'Failed to fetch audios',
      }
    }
  } catch (error) {
    console.error('Error trying to fetch audios', error)
    return {
      success: false,
      message: 'An error occurred during fetching audios',
    }
  }
}

export const createAudio = async (
  audioData: FormData
): Promise<CreateAudioResponse> => {
  try {
    const response = await fetch(`${API_URL}/audio-podcasts`, {
      method: 'POST',
      headers: createFormDataAuthHeaders(),
      body: audioData,
    })
    const data = await response.json()
    if (response.ok) {
      return {
        success: true,
        audioPodcast: data.audioPodcast,
        message: data.message,
      }
    } else {
      return {
        success: false,
        message: data.message || 'Failed to create audio',
      }
    }
  } catch (error) {
    console.error('Error trying to create an audio', error)
    return {
      success: false,
      message: 'An error occurred during audio creation',
    }
  }
}

export const updateAudio = async (
  id: string,
  audioData: FormData
): Promise<UpdateAudioResponse> => {
  try {
    const response = await fetch(`${API_URL}/audio-podcasts/${id}`, {
      method: 'PUT',
      headers: createFormDataAuthHeaders(),
      body: audioData,
    })
    const data = await response.json()
    if (response.ok) {
      return {
        success: true,
        audioPodcast: data.podcast,
        message: data.message,
      }
    } else {
      return {
        success: false,
        message: data.message || 'Failed to update audio',
      }
    }
  } catch (error) {
    console.error('Error trying to update an audio', error)
    return {
      success: false,
      message: 'An error occurred during audio update',
    }
  }
}

export const deleteAudio = async (id: string): Promise<DeleteAudioResponse> => {
  try {
    const token = getAdminToken()
    const headers: HeadersInit = {}
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
    
    const response = await fetch(`${API_URL}/audio-podcasts/${id}`, {
      method: 'DELETE',
      headers,
    })
    const data = await response.json()
    if (response.ok) {
      return { success: true, audioPodcast: data.audioPodcast }
    } else {
      return {
        success: false,
        message: data.message || 'Failed to delete audio',
      }
    }
  } catch (error) {
    console.error('Error trying to delete an audio', error)
    return {
      success: false,
      message: 'An error occurred during audio deletion',
    }
  }
}
